module.exports = __webpack_public_path__ + "assets/img/about1.5af09bb2.jpg";